import React from 'react';
import { Button as BaseButton } from '@material-ui/core/';
import PropTypes from 'prop-types';

const Button = (props) => {
  return (
    <BaseButton
      className={props.className}
      type={props.type}
      classes={props.classes}
      variant={props.variant}
      color={props.color}
      disabled={props.disabled}
      fullWidth={props.fullWidth}
      onClick={props.onClick}
    >
      {props.children}
    </BaseButton>
  );
};

Button.defaultProps = {
  variant: 'text',
  color: 'default',
  disable: false,
  fullWidth: false,
};

Button.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default Button;
